/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ============================================================================
 * Carrello dinamico header (stile AutoDoc) — Tema Alessandro, 2026-05
 * Aggiorna in tempo reale "N articoli" e il prezzo totale accanto al carrello.
 * Sorgenti: hook del tema (product:added / cart:refresh) + MutationObserver sul
 * badge .header__cart-count (copre anche rimozioni e modifiche quantita').
 * ========================================================================== */
(function () {
  'use strict';

  // Formatta i centesimi usando il money_format del negozio (window.theme.moneyFormat).
  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '{{amount}}';

    function group(value, decimals, thousandsSep, decimalSep) {
      value = (value / 100).toFixed(decimals);
      var parts = value.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousandsSep);
      return whole + (parts[1] ? decimalSep + parts[1] : '');
    }

    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, name) {
      switch (name) {
        case 'amount':                                  return group(cents, 2, ',', '.');
        case 'amount_no_decimals':                      return group(cents, 0, ',', '.');
        case 'amount_with_comma_separator':             return group(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
        case 'amount_with_space_separator':             return group(cents, 2, ' ', ',');
        case 'amount_with_apostrophe_separator':        return group(cents, 2, "'", '.');
        default:                                        return group(cents, 2, '.', ',');
      }
    });
  }

  function applyCart(cart) {
    document.querySelectorAll('[data-cart-total]').forEach(function (el) {
      el.innerHTML = formatMoney(cart.total_price);
    });
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
  }

  var debounce;
  function refreshCart() {
    clearTimeout(debounce);
    debounce = setTimeout(function () {
      var url = ((window.routes && window.routes.cartUrl) || '/cart') + '.js';
      fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (response) { return response.json(); })
        .then(applyCart)
        .catch(function () { /* lascia i valori renderizzati lato server */ });
    }, 80);
  }

  // Hook documentati dal tema Warehouse.
  document.addEventListener('product:added', refreshCart);
  document.addEventListener('cart:refresh', refreshCart);

  // Catch-all: ogni volta che il tema aggiorna il contatore del carrello.
  function watchCartBadge() {
    var badge = document.querySelector('.header__cart-count');
    if (!badge) return;
    new MutationObserver(refreshCart).observe(badge, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCartBadge);
  } else {
    watchCartBadge();
  }
})();

